import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-new-ticket-dialog',
  templateUrl: './new-ticket-dialog.component.html',
  styleUrls: ['./new-ticket-dialog.component.scss']
})
export class NewTicketDialogComponent implements OnInit {

  //createRequest: FormControl = new FormControl();

  formData = new FormData();

  spinner: boolean;
  requestForm: FormGroup;
  customerData: any;
  userId: string;
  userRoles: string;
  custId: any;
  submitted: boolean;
  userInfo: any;
  attachmentName: string;
  chassisNo: any[] = [];
  uiFileName: any;
  showDownloadButton: boolean;
  buttonFlag: boolean;

  constructor(private commonService: CommonService, private router: Router, private toastr: ToastrService,
    private formBuilder: FormBuilder, private dialogRef: MatDialogRef<NewTicketDialogComponent>) {
     }

  ngOnInit() {
    this.customerData = JSON.parse(localStorage.getItem('customerData'));
    this.userId = localStorage.getItem('userId');
    this.userRoles = localStorage.getItem('userRoles');
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userInfo = userInfo[0];
    this.buildLoginForm();
    this.buttonFlag = false;
  }

  /**
  * Name: buildLoginForm
  * purpose: To create customer data form
  */
  buildLoginForm() {
    this.requestForm = this.formBuilder.group({
      customerID: ['', Validators.required],
      correctCustomerName: ['', Validators.required],
      incorrectCustomerName: ['', Validators.required],
      vin: ['', Validators.required],
      correctCustomerNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      incorrectCustomerNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]]
    });
  }

  newTicket() {
    this.submitted = true;
    this.buttonFlag = true;
    this.spinner = true;
    let status = "";

    if(this.userInfo.roleId != "1") {
      status = "accept";
    } else {
      status = "";
    }

    if(this.requestForm.valid) {
      let request = '{' +
        '"custId" : "' + this.requestForm.value.customerID + '","custNameCorrect" : "' + this.requestForm.value.correctCustomerName
        + '","custNameInCorrect" : "' + this.requestForm.value.incorrectCustomerName + '","vin" : "' + this.requestForm.value.vin
        + '","custContactNoCorrect" : "' + this.requestForm.value.correctCustomerNumber + '","custContactNoInCorrect" : "' + this.requestForm.value.incorrectCustomerNumber
        + '","attechment" : "' + "" + '","remarks" : "' + "" + '","fleetNameCorrect" : "' + "" + '","fleetContactNoCorrect" : "' + ""
        + '","fleetNameInCorrect" : "' + "" + '","fleetContactNoInCorrect" : "' + "" + '","driverName" : "' + ""
        + '","driverContactNo" : "' + "" + '","sourceId" : "' + "SRM" +'","status" : "' + status + '"}';
      let data = {
        file: this.formData,
        model: request,
      };
      this.commonService.createNewTicket(this.userId, this.userInfo.roleId, data)
        .subscribe(res => {
          if (res['responseCode'] == 0 && res['responseData'] != undefined) {
            this.toastr.success(res['message'], "Success");
            this.submitted = false;
            this.spinner = false;
          } else {
            this.spinner = false;
            this.submitted = false;
            this.toastr.error(res['message'], "Error");
          }

          this.closeDialog();
        }, err => {
          this.spinner = false;
          this.toastr.error("Something went wrong, Please try again.", "Error");
        });
    }
  }

  closeDialog() {
    this.close();
    this.dialogRef.close(false);
  }

  close() {
    this.dialogRef.close(false);
  }

  /**
  * Name: hasCustDataError
  * purpose: To check if customer form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasError(control: any): boolean {
    return (
      control &&
      (this.submitted || control.touched || control.dirty) &&
      !control.valid
    );
  }

  onFileUpload(event: any) {
    this.attachmentName = "";
    this.formData = new FormData();
    let file: File = event.target.files[0];
    this.attachmentName = file.name;
    let filePath = event.currentTarget.value.split("\\")[2];
    this.formData.append('file', file, filePath);
  }

  clear(): void {
    this.requestForm.reset();
  }
}
